import React, { useRef, useState } from "react";
import EmojiPicker, { EmojiClickData } from "emoji-picker-react";

// Type definitions

type FormatKey = "star_rating" | "1-5_rating" | "1-10_rating" | "emoji_rating";

interface ScoringFormat {
  label: string;
  scores: (string | { emoji: string; label: string })[];
}

interface ScoringSelectorProps {
  selectedFormat: FormatKey | "";
  descriptions: Record<FormatKey, Record<number, string>>;
  setSelectedFormat: (format: FormatKey | "") => void;
  setDescriptions: any;
  scoringFormats: Record<FormatKey, ScoringFormat>;
  selectedEmojis: any;
  setSelectedEmojis: any;
  setPickerIndex: any;
  setPickerVisible: any;
  updatePickerPosition: any;
  inputRefs: any;
  pickerVisible: any;
  pickerPosition: any;
  handleEmojiSelect: any;
  handleDescriptionChange: any;
}

const ScoringSelector: React.FC<ScoringSelectorProps> = ({
  selectedFormat,
  descriptions,
  setSelectedFormat,
  setDescriptions,
  scoringFormats,
  selectedEmojis,
  setSelectedEmojis,
  setPickerIndex,
  setPickerVisible,
  updatePickerPosition,
  inputRefs,
  pickerVisible,
  pickerPosition,
  handleEmojiSelect,
  handleDescriptionChange
}) => {


  const renderScoreInputs = () => {
    if (selectedFormat === "emoji_rating")
      return (
        <>
          {[0, 1, 2, 3, 4].map((index) => (
            <div key={index} className="flex items-center mb-2 space-x-4 relative">
              <div className="w-5 text-right">{index + 1}</div>
              <button
                onClick={() => {
                  setPickerIndex(index);
                  updatePickerPosition(index);
                  setPickerVisible(true);
                }}
                className="text-xl border rounded px-2 py-1 bg-white"
              >
                {selectedEmojis[index] || "➕"}
              </button>
              <input
                ref={(el) => (inputRefs.current[index] = el)}
                type="text"
                className="border p-1 rounded flex-1"
                value={descriptions.emoji_rating?.[index] ?? ""}
                onChange={(e) => handleDescriptionChange(index, e.target.value)}
                placeholder={"Enter description"}
              />
            </div>
          ))}

          {pickerVisible && (
            <div
              className="absolute z-50"
              style={{ top: 0, left: 450 }}
            >
              <EmojiPicker
                onEmojiClick={handleEmojiSelect}
                height={350}
                width={300}
                skinTonesDisabled
              />
            </div>
          )}
        </>
      );

    const format = scoringFormats[selectedFormat as FormatKey];
    return format?.scores?.map((score, index) => {
      const label = typeof score === "string" ? score : score.label;
      const emoji = typeof score === "string" ? null : score.emoji;

      return (
        <div key={index} className="flex items-center mb-2 space-x-16">
          <span className="w-8 text-right">
            {selectedFormat === "star_rating"
              ? "★".repeat(index + 1)
              : selectedFormat === "1-5_rating" || selectedFormat === "1-10_rating"
                ? index + 1
                : emoji}
          </span>
          <input
            type="text"
            className="border p-1 rounded flex-1"
            value={descriptions[selectedFormat as FormatKey]?.[index] ?? label}
            onChange={(e) => handleDescriptionChange(index, e.target.value)}
          />
        </div>
      );
    });
  };

  return (
    <div className="p-0 space-y-7 flex flex-col items-center justify-center relative">
      <fieldset className="grid grid-cols-2 grid-rows-2 gap-4 w-full max-w-md">
        {Object.entries(scoringFormats).map(([key, format]) => (
          <label key={key} className="flex items-center space-x-2">
            <input
              type="radio"
              name="scoreFormat"
              value={key}
              checked={selectedFormat === key}
              onChange={() => setSelectedFormat(key as FormatKey)}
            />
            <span>{format?.label}</span>
          </label>
        ))}
      </fieldset>

      {selectedFormat && (
        <div className="mt-4 bg-white border rounded-lg p-4 w-[400px] max-w-full relative">
          <h3 className="text-md font-semibold mb-3">
            {scoringFormats[selectedFormat as FormatKey]?.label}  {selectedFormat === "1-10_rating" ? "(1 is Poor, 10 is Very good)" : "(1 is Poor, 5 is Very good)"}
          </h3>
          {renderScoreInputs()}
        </div>
      )}
    </div>
  );
};

export default ScoringSelector;